<template>
    <div class="c-copy">
        <h1 class="c-copy__title" >
            <slot  name="title"></slot>
        </h1>
        <div class="c-copy__text">
            <slot name="text">test</slot>
        </div>
    </div>
</template>
<script>
export default {
}
</script>
<style lang="scss">
    .c-copy{
        &__title{
            font-size: 2.2rem;
            margin: 0 0 4rem 0;
        }
        &__text{

        }
    }
</style>